import * as z$1 from "zod/v4";
//#region src/schemas/agent-view/center-agent.ts
const centerAgentOrganizationTargetSchema = z$1.strictObject({
	id: z$1.string().trim().min(1),
	name: z$1.string().trim().min(1),
	personal: z$1.boolean().optional(),
	role: z$1.string().trim().min(1).optional(),
	slug: z$1.string().trim().min(1)
});
const centerAgentOrganizationScopeSchema = z$1.strictObject({
	selection: z$1.enum(["current", "explicit"]),
	target: centerAgentOrganizationTargetSchema
});
//#endregion
export { centerAgentOrganizationScopeSchema, centerAgentOrganizationTargetSchema };

//# sourceMappingURL=center-agent.js.map